<template>
  <div>
    <b-modal
      title="契約批次銷帳"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      :no-close-on-backdrop="true"
      v-model="modalShow"
    >
      <b-alert show variant="warning">
        已勾選總計：{{ tickedTotal }}
      </b-alert>

      <!-- <b-form-tags
        input-id="tags-pills"
        v-model="unPaidBill.contractNumber"
        tag-variant="primary"
        :no-tag-remove="true"
        tag-pills
        size="lg"
        separator=" "
        class="mb-3"
        duplicateTagText="重複契約編號"
        placeholder="請輸入契約編號後按Enter"

        @tag-state="searchContract"
      ></b-form-tags> -->

      <b-form-tags
        v-model="unPaidBill.contractNumber"
        no-outer-focus
        no-add-on-enter class="mb-2"
      >
        <template v-slot="{ tags, inputAttrs, inputHandlers, tagVariant, removeTag }">
          <b-form @submit.prevent="addTag(inputAttrs)">
            <b-input-group class="mb-2">
              <b-form-input v-bind="inputAttrs" v-on="inputHandlers" placeholder="請輸入關鍵字後按Enter" class="form-control" :state="state"></b-form-input>

              <b-input-group-append>
                <b-button @click="addTag(inputAttrs)" variant="primary">Add</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>

          <div class="d-inline-block" style="font-size: 1.5rem;">
            <b-form-tag v-for="tag in unPaidBill.contractNumber"
              @remove="removeTags(tag)"
              :key="tag"
              :title="tag"
              :variant="tagVariant"
              class="mr-1"
            >
              {{ tag }}
            </b-form-tag>
          </div>
        </template>
      </b-form-tags>

      <b-form-checkbox
        class="mb-2"
        switch
        size="lg"
        v-model="status.autoDeduction"
        @change="autoDeduction"
      >
        自動扣款
      </b-form-checkbox>

      <div class="set-up">
        <date-picker
          v-model="setUp.payment_at"
          :position="'right'"
          placeholder="繳款日期"
        ></date-picker>

        <b-form-select
          v-model="setUp.payment_source"
          :options="options.payment"
          text-field="label"
          value-field="label"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>--請選擇繳款來源--</b-form-select-option>
          </template>
        </b-form-select>

        <div class="btn-function">
          <b-button variant="danger" @click="clearAll()">清空全部</b-button>

          <b-button variant="success" @click="setUpAll()">設定全部</b-button>
        </div>
      </div>

      <tables-page
       :tableData="unPaidBill.table_data"
        :tableFields="unPaidBill.table_fields"
        :isBackendSorting="false"
      >
        <template #head(checkbox)>
          <b-form-checkbox v-model="status.isCheckboxAll" @change="toggleCheckboxAll"></b-form-checkbox>
        </template>

        <template #cell(checkbox)="row">
           <b-form-checkbox v-model="row.item.checkbox"></b-form-checkbox>
        </template>

        <template #cell(payment_at)="row">
          <date-picker
            v-model="row.item.payment_at"
            :position="'left'"
          ></date-picker>
        </template>

        <template #cell(payment_source)="row">
          <b-form-select
            v-model="row.item.payment_source"
            :options="options.payment"
            text-field="label"
            value-field="label" />
        </template>

        <template #cell(type)="row">
          <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
        </template>

        <template #cell(dead_at)="row">
          {{ convertRocDate(row.item.dead_at) }}
        </template>

        <template #cell(updated_at)="row">
          {{ convertRocDate(row.item.updated_at) }}
        </template>
      </tables-page>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit"
        >
          確定
        </b-button>

        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import datePicker from '@/components/common/DatePicker';
import billApi from "@/models/API/billApi";
import { convertRocDate, getBillTypeColor, getBillFeeDescription } from "@/models/HELPERS/common.js";

export default {
  name: 'BatchContractRemoveBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TablesPage,
    datePicker
  },
  data () {
    return {
      options: {
        payment: [
          {
            label: '現金',
            value: 0
          },
          {
            label: '全家',
            value: 1
          },
          {
            label: '新光',
            value: 2
          },
          {
            label: '萬事達',
            value: 3
          },
          {
            label: '郵局臨櫃',
            value: 4
          },
          {
            label: '郵局劃撥',
            value: 5
          },
          {
            label: '網路ATM',
            value: 6
          },
          {
            label: '台中商銀',
            value: 7
          },
          {
            label: '支票',
            value: 8
          },
          {
            label: '自動',
            value: 9
          },
          {
            label: '年費抵用券',
            value: 10
          },
        ]
      },
      unPaidBill: {
        table_fields: [
          {
            key: "checkbox",
            label: "銷帳",
          },
          {
            key: "payment_at",
            label: "繳款日期",
          },
          {
            key: "payment_source",
            label: "繳款來源",
          },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人姓名",
            sortable: true
          },
          {
            key: "month",
            label: "帳單月份",
            sortable: true
          },
          {
            key: "period",
            label: "帳單期別",
            sortable: true
          },
          {
            key: "type",
            label: "類型",
            sortable: true
          },
          {
            key: "amount",
            label: "互助金",
            sortable: true
          },
          {
            key: "remark",
            label: "備註"
          },
          {
            key: "dead_at",
            label: "繳款期限",
          },
          {
            key: "updated_at",
            label: "異動時間",
          }
        ],
        table_data: [],
        contractNumber: []
      },
      search: {
        receive: ''
      },
      setUp: {
        payment_at: '',
        payment_source: null
      },
      status: {
        isCheckboxAll: false,
        autoDeduction: false,
        isLoading: false
      },
      state: null,
      saveAutoDeductionContractData: []
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    tickedTotal() {
      if (this.unPaidBill.table_data.length === 0) return 0;

      const total = this.unPaidBill.table_data.reduce((accumulator, currentValue) => {
        return currentValue.checkbox ? accumulator + Number(currentValue.amount) : accumulator
      }, 0);

      return total;
    }
  },
  watch: {
     show: {
      handler(newValue, oldValue) {

      },
      immediate: false
    }
  },
  mounted() {
    this.billApi = new billApi();
  },
  methods: {
    convertRocDate,
    getBillTypeColor,
    getBillFeeDescription,
    // 新增標籤
    async addTag(inputAttrs) {
      const value = inputAttrs.value;
      const is_redundant_number = this.unPaidBill.contractNumber.some(item => item === value);

      if (!value || is_redundant_number) return;

      const res = await this.getBill(value);

      // if (Object.values(res).length > 0) {
      //   this.unPaidBill.contractNumber.push(value);
      //   this.unPaidBill.table_data = [...this.unPaidBill.table_data, ...res.details];
      //   this.state = null;
      //   inputAttrs.value = "";
      // } else {
      //   this.state = false;
      // }

      if (res.length > 0) {
        this.addContractDataHandler(res);

        this.state = null;
        inputAttrs.value = "";
      } else {
        this.state = false;
      }
    },
    // 移除標籤
    removeTags(...tag) {
      tag.forEach(tag_item => {
        this.unPaidBill.contractNumber = this.unPaidBill.contractNumber.filter(item => item !== tag_item);
        this.unPaidBill.table_data = this.unPaidBill.table_data.filter(item => item.number !== tag_item);
      })
      this.state = null;
    },
    // 核取方塊 全選 || 取消全選 開關
    toggleCheckboxAll() {
      this.unPaidBill.table_data.map(item => {
        this.$set(item, 'checkbox', this.status.isCheckboxAll)
      });
    },
    // 查詢帳單
    getBill(value) {
      return new Promise((resolve) => {
        this.status.isLoading = true;

        const params = {
          ...this.search,
          'blur': value,
          'class': 1,
        };

        this.billApi.getBill((response) => {
          const res = response.data;
          let data = [];

          if (res.data.length > 0) {
            data = res.data.map(item => {
              return {
                ...item,
                details: item.details.map(details_item => {
                  return {
                    ...details_item,
                    number: item.number,
                    member_name: item.member_name,
                    payment_at: '',
                    payment_source: ''
                  }
                })
              }
            })

            // let data = {};

            //  data = {
            //   ...res.data[0],
            //   details: res.data[0].details.map(details_item => {
            //     return {
            //       ...details_item,
            //       number: res.data[0].number,
            //       member_name: res.data[0].member_name,
            //       payment_at: '',
            //       payment_source: ''
            //     }
            //   })
            //  }
          }

          resolve(data);

          this.status.isLoading = false;
        }, params)
      });
    },
    // 自動扣款
    async autoDeduction() {
      if (this.status.autoDeduction) {
        this.search.receive = 6;

        const res = await this.getBill();
        let result = '';

        if (res.length > 0) {
          result = { message: '自動扣款加入成功', title: '契約批次銷帳' };

          this.addContractDataHandler(res);
          this.saveAutoDeductionContractData = res.map(item => item.number);
        } else {
          result = { message: '自動扣款查無資料!!', title: '契約批次銷帳' };

          this.status.autoDeduction = false;
        }

        this.billApi.toast(() => {}, result, res.length > 0);
        this.search.receive = '';
      } else {
        this.removeTags(...this.saveAutoDeductionContractData);

        this.saveAutoDeductionContractData = [];
      }
    },
    // 新增契約資料處理
    addContractDataHandler(data = []) {
      data.forEach(bill_item => {
        const is_redundant_number = this.unPaidBill.contractNumber.some(item => item === bill_item.number);

        if (!is_redundant_number) {
          this.unPaidBill.contractNumber.push(bill_item.number);
          this.unPaidBill.table_data = [...this.unPaidBill.table_data, ...bill_item.details];
        }
      });
    },
    sumit() {
      this.$emit('sumit', this.unPaidBill.table_data);
    },
    // 重置搜尋條件
    resetSearchCondition() {
      this.setUp = {
        payment_at: '',
        payment_source: null
      };
      this.unPaidBill.contractNumber = [];
      this.unPaidBill.table_data = [];
    },
    // 清空全部
    clearAll() {
      this.unPaidBill.table_data.map(item => {
        this.$set(item, 'payment_at', '');
        this.$set(item, 'payment_source', '');
      });
    },
    // 設置全部
    setUpAll() {
      this.unPaidBill.table_data.map(item => {
        this.$set(item, 'payment_at', this.setUp.payment_at);
        this.$set(item, 'payment_source', this.setUp.payment_source);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.set-up {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 20px;
  .btn-function {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/BatchContractRemoveBillModal.vue